import { Injectable } from '@angular/core';
import { VendorOAuthRegistrationService } from "./Integration/api/vendorOAuthRegistration.service";
import { VendorOAuthRegistration } from './Integration/model/vendorOAuthRegistration';
import { vendorEnum } from './../../../assets/config/model/vendorEnums';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  public organizationId: number;
  public vendorId: number;
  private settings;
  constructor(private vendorService?: VendorOAuthRegistrationService) {
    this.organizationId = 3;
    this.vendorId = vendorEnum.outlook;
  }

  MSALConfigFactory(): Promise<any> {
    let config = this.getConfigurationDetails().then((res: VendorOAuthRegistration) => {
      const obj = {
        auth: {
          clientId: res.clientId,
        },
      }
      this.settings = obj;
      return obj;
    });
    return config.then((res) => res);
  }

  getSettings(): any {
    return this.settings;
  }

  getConfigurationDetails(): Promise<any> {
    return new Promise(() => {});
  }
}
